module.exports = "/assets/data/4efc28814cb99e68a60ddb01e5baaded-CF48.data.json";